"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFilesCarousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
require("react-multi-carousel/lib/styles.css");
var UploadFilesButton_1 = require("../../molecules/UploadFilesButton");
var Media_1 = require("./Media");
var Files_1 = require("./Files");
var utils_1 = require("../../utils");
/**
 * @deprecated
 */
exports.UploadFilesCarousel = react_1.default.memo(function (_a) {
    var _b = _a.acceptedFileTypes, acceptedFileTypes = _b === void 0 ? 'image/*,video/*,.xlsx,.xls,.doc, .docx,.ppt, .pptx,.txt,.pdf' : _b, _c = _a.defaultFiles, defaultFiles = _c === void 0 ? [] : _c, _d = _a.onChange, onChange = _d === void 0 ? function () { } : _d;
    var _e = (0, react_1.useState)(defaultFiles), files = _e[0], setFiles = _e[1];
    var isMedia = (0, react_1.useCallback)(function (item) { return item.type.includes('image') || item.type.includes('video'); }, []);
    var _f = (0, react_1.useMemo)(function () {
        return files.reduce(function (_a, item) {
            var m = _a[0], f = _a[1];
            if (item.file) {
                return isMedia(item.file) ? [__spreadArray(__spreadArray([], m, true), [item], false), f] : [m, __spreadArray(__spreadArray([], f, true), [item], false)];
            }
            if (item.original || item.web || item.thumbnail) {
                return [__spreadArray(__spreadArray([], m, true), [item], false), f];
            }
            return [m, __spreadArray(__spreadArray([], f, true), [item], false)];
        }, [[], []]);
    }, [files, isMedia]), mediaL = _f[0], filesL = _f[1];
    var deleteAttachment = (0, react_1.useCallback)(function (id, property) {
        var updatedList = files.filter(function (item) {
            var prop = (0, utils_1.getProp)(item, property) || (0, utils_1.getProp)(item, 'file.name');
            return prop !== id;
        });
        setFiles(updatedList);
        onChange(updatedList);
    }, [files, onChange]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ role: "grid" }, { children: [(0, jsx_runtime_1.jsx)(Media_1.Media, { uploadButton: (0, jsx_runtime_1.jsx)(UploadFilesButton_1.UploadFilesButton, { multiple: true, acceptedFileTypes: acceptedFileTypes, isPlusIconButton: true, handler: function (fileList) {
                        setFiles(__spreadArray(__spreadArray([], fileList, true), files, true));
                        onChange(__spreadArray(__spreadArray([], fileList, true), files, true));
                    } }), attachmentList: mediaL, deleteHandler: deleteAttachment }), (0, jsx_runtime_1.jsx)(Files_1.Files, { attachmentList: filesL, deleteHandler: deleteAttachment })] })));
});
